<template>
	<div class="ReHouseClassMap">
		<yandex-map
			:settings="yamap_settings"
			:coords="yamap_coords"
			:zoom="yamap_zoom"
			:controls="yamap_controls"
			:scroll-zoom="true"
			:cluster-options="clusterOptions"
			:use-html-in-layout="true"
			>
				<ymap-marker v-for="marker in yamap_markers" :key="marker.id"
					:coords="marker.coords"
					:marker-id="marker.id"
					:icon="{color: marker.markerColor, content: marker.houseClassMarker}"
					:balloon-template="marker.balloonTemplate"
					:balloon="marker.clusterBalloonTemplate"
					cluster-name="cluster"
				/>
		</yandex-map>
	</div>
</template>

<script>
	import { yandexMap, ymapMarker } from 'vue-yandex-maps';
	import mapSettings from 'src/conf/yandexmap.js';
	export default {
		name: 'ReHouseClassMap',
		components: { 
			yandexMap, 
			ymapMarker,
		},
		props: {
			objData: [Object,Array]
		},
		data () {
			return {
				ver: 1,
				yamap_settings: {...mapSettings},
				yamap_coords: [59.93984485554249, 30.314527237792984],
				yamap_zoom: 11,
				yamap_controls:['zoomControl','typeSelector'],
				yamap_markers:[],
				clusterOptions: {
					clusterDisableClickZoom: true,
					clusterOpenBalloonOnClick: true,
				},
				updateTimer:null,
			}
		},
		watch: {
			objData(val){
				this.makeMarkers();
			}
		},
		methods: {
			makeMarkers(){
				//this.yamap_markers = [];
				let markers=[];
				// const objGetParams = this.$GVO.GetAllGet();
				
				for (let i = 0; i < this.objData.length; i++) {
					const objHouse= this.$GVO.unlinkObject(this.objData[i]);
					// let strImg = '/img/icons/map/map_icon_ready.svg';
					
					// let strConstGetParams = '';
					// if(typeof objGetParams.task_id != 'undefined' && typeof objGetParams.taskend_id != 'undefined' && typeof objGetParams.client_id != 'undefined'){
					// 	strConstGetParams = `?task_id=${objGetParams.task_id}&taskend_id=${objGetParams.taskend_id}&client_id=${objGetParams.client_id}`;
					// }
					const markerColor = 'grey';
					const houseClassMarker = 'Не определено';
					const className = '';

					if(objHouse.cat_living_class_name == null) {
						className = 'Не классифицирован';
					} else {className = objHouse.cat_living_class_name;}

					if(objHouse.cat_living_class_id == '3'){
						markerColor = 'yellow';
						houseClassMarker = 'Комф.';						
					}else if(objHouse.cat_living_class_id == '2') {
						markerColor = 'red';
						houseClassMarker = 'Бизнес';
					}else if(objHouse.cat_living_class_id == '1') {
						markerColor = 'lightBlue';
						houseClassMarker = 'Станд.';
					}					

					markers.push({
						id: i,
						markerId: i,
						coords: [objHouse.lat, objHouse.lng],
						markerColor: markerColor,
						houseClassMarker: houseClassMarker,
						// markerIcon: {
						// 	layout: 'default#imageWithContent',
						// 	imageSize: [33, 40],
						// 	imageOffset: [-18, -35],				
						// },						
						clusterBalloonLayout: {
							clusterBalloonLayout: [
							'<ul class=list>',
							'{% for geoObject in properties.geoObjects %}',
							'<li><a href=# class="list_item">{{ geoObject.properties.balloonContentHeader|raw }}</a></li>',
							'{% endfor %}',
							'</ul>',
							].join(''),
						}, 
						clusterBalloonTemplate: {
							header: `Адрес: ${objHouse.address}`,
							body:
							`ID: ${objHouse.id} \r\n
							Класс: ${objHouse.cat_living_class_name} \r\n
							Год постройки: ${objHouse.year} \r\n
							Серия (тип дома): ${objHouse.series_building} \r\n							
							`,
						},
						balloonTemplate: `
							<div class="cardComplex" style="height: auto !important;">
								<!--
								<p>Класс дома: objHouse.cat_living_class_name </p>
								<p>Ответственный: objHouse.agent_name </p>
								-->
								<div>	
									<p>ID: ${objHouse.id} </p>
									<p>Адрес: ${objHouse.address} </p>
									<p>Класс: ${className} </p>
									<p>Год постройки: ${objHouse.year}</p>
									<p>Серия (тип дома): ${objHouse.series_building}</p>
								</div>
							</div>
						`
					});
				}
				clearTimeout(this.updateTimer);
				this.updateTimer= setTimeout(()=>{
					this.yamap_markers=markers;
				},10);
				this.yamap_markers=[];
			},
			
			
		},
		mounted() {
			this.makeMarkers();
		}
	}
</script>

<style>
	.ymap-container{height: 600px; width: 100%;}
	.ReSearchObjMap{position: relative; width: 100%;}
	.cardComplex .img{
		width: 100%;
		margin: 0 auto;
    	display: flex;
		margin-bottom: 15px;
		padding-top: 15px;
	}
	.cardComplex .img img{max-width: 300px; object-fit: cover;}
	.cardComplex .img a{display: inline-block; margin: 0 auto;}
	.cardComplex p {color: #000;}
	.complexName {margin-bottom: 5px;}
	.metroPathTime, .districtStreet {display: flex; align-items: center;}
	.objInfo {padding: 0px 10px;}
	.flatCount {margin-bottom: 5px;}
	.ymaps-2-1-77-balloon__content{
		margin-right: 0px!important;
		padding: 20px!important;
	}
	/*===media===============================*/
	@media (max-width: 768px) {	
		.ymap-container {height: 450px; color:#7a7a7a;}
	}
</style>
